import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import { App } from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { getPetsOrdered } from "./utils/apiWrapper";
import { FilterProvider } from "./components/FilterProvider";
import { PetsProvider } from "./components/PetsProvider";

ReactDOM.render(
  <React.StrictMode>
    <FilterProvider>
      <PetsProvider>
        <App getPetsOrdered={getPetsOrdered} />
      </PetsProvider>
    </FilterProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
